var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2097",
    "data-name": "Group 2097",
    transform: "translate(-970 -298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_38",
    "data-name": "Ellipse 38",
    transform: "translate(970 298)",
    fill: "none",
    stroke: "#ff4b3c",
    strokeWidth: 7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 46,
    r: 46,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 46,
    r: 42.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_46393",
    "data-name": "Path 46393",
    d: "M993.364,344h45.431",
    transform: "translate(540.848 -617.721) rotate(45)",
    fill: "none",
    stroke: "#ff4b3c",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46394",
    "data-name": "Path 46394",
    d: "M0,0H45.431",
    transform: "translate(1032.143 327.938) rotate(135)",
    fill: "none",
    stroke: "#ff4b3c",
    strokeWidth: 7
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.b5e99cc854d7882f876b04680a578e7f.svg";
export { ForwardRef as ReactComponent };